import {
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";

import { AuthService } from "./../../services/auth.service";

@Component({
  selector: "mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrls: ["./mobile-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  @ViewChild("sidebarIconToggle") sidebarIconToggle;
  @ViewChild("sidebarMenu") sidebarMenu;
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;
  private clickUnlisten: () => void;
  private _subscriptions$: Subscription[] = [];

  isToggled: boolean;

  constructor(
    private router: Router,
    public authService: AuthService,
    private renderer: Renderer2,
  ) {
    this._subscriptions$.push(this.onRouteChange());
  }

  ngOnInit(): void {
    this.clickUnlisten = this.onClickAnywhere();
  }

  onRouteChange() {
    return this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isToggled = false;
      }
    });
  }

  toggleMenu() {
    this.isToggled = !this.isToggled;
  }

  private onClickAnywhere() {
    return this.renderer.listen("window", "click", (e: Event) => {
      if (
        e.target !== this.sidebarIconToggle.nativeElement &&
        !(e.target as HTMLElement).closest("#sidebarMenu")
      ) {
        this.isToggled = false;
      }
    });
  }

  ngOnDestroy() {
    this._subscriptions$.forEach((a) => a.unsubscribe());
    this.clickUnlisten();
  }
}
